import { useMemo } from 'react'

import createSelector from 'lib/createSelector'
import { getBedbankRateKey } from 'actions/BedbankOfferActions'
import { useAppSelector } from 'hooks/reduxHooks'

const DEFAULT_RESULT = { rates: {}, hasLoading: false }

const getRates = createSelector(
  (state: App.State) => state.offer.offerRatesLoading,
  (state: App.State) => state.offer.bedbankOfferRates,
  (state: App.State, offerIds: Array<string>) => offerIds,
  (state: App.State, offerIds: Array<string>, filterKey: string) => filterKey,
  (offerRatesLoading, bedbankOfferRates, offerIds, filterKey) =>
    offerIds.reduce((acc, offerId) => {
      if (offerRatesLoading[offerId]) {
        acc.hasLoading = true
        return acc
      }

      const rate = bedbankOfferRates[offerId]?.[filterKey]?.[0]
      if (rate) {
        acc.rates[offerId] = rate
      }
      return acc
    }, { ...DEFAULT_RESULT }),
)

function useBatchBedbankStickerRates(
  offerIds: Array<string>,
  occupants?: Array<App.Occupants>,
  checkIn?: string,
  checkOut?: string,
) {
  const filterKey = useMemo(() => getBedbankRateKey(
    occupants,
    checkIn,
    checkOut,
  ), [occupants, checkIn, checkOut])

  return useAppSelector((state) => getRates(state, offerIds, filterKey))
}

export default useBatchBedbankStickerRates
